import React from 'react';

const STEPS = [
  {
    number: '01',
    title: 'Discover',
    desc: 'Browse designs from independent designers and creatives worldwide. Filter by style, designer, school, or availability — every piece is original.',
  },
  {
    number: '02',
    title: 'Try On Virtually',
    desc: 'See how any piece looks on you with AI-powered virtual try-on. No commitment — just the experience of wearing something extraordinary.',
  },
  {
    number: '03',
    title: 'Rent, Wear, or Collect',
    desc: 'Rent couture for a shoot or event, experience it through virtual try-on, or collect digital fashion. Direct from the designer — you support the creator, not a middleman.',
  },
];

const HowItWorksSection = () => {
  return (
    <section className="landing-how-section">
      <div className="landing-section-label">How It Works</div>
      <h2 className="landing-section-title">Three steps to wearable art</h2>
      <div className="landing-how-grid">
        {STEPS.map((step) => (
          <div className="landing-how-card" key={step.number}>
            <div className="landing-how-number">{step.number}</div>
            <div className="landing-how-card-title">{step.title}</div>
            <div className="landing-how-desc">{step.desc}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorksSection;
